module.exports = __webpack_public_path__ + "media/VideoOiltanking-Otamerica-10.11.23.4340a573.mp4";